import React from 'react';
import { Clock, Languages, Linkedin, Mail, MapPin, MessageCircle, Phone } from 'lucide-react';
import portraitImage from '../assets/espaces-culturel/moi-sans-fond.png';
import { useLocale } from '../context/LocaleContext';

const ContactAside = ({ className = '' }) => {
  const { t } = useLocale();

  const channels = [
    {
      id: 'email',
      icon: Mail,
      label: t('contact_channel_email'),
      value: 'fossiflorent@gmail.com',
      href: 'mailto:fossiflorent@gmail.com',
    },
    {
      id: 'phone-1',
      icon: Phone,
      label: t('contact_channel_phone'),
      value: '+237 693 690 308',
      href: 'https://wa.me/237693690308',
      external: true,
    },
    {
      id: 'phone-2',
      icon: Phone,
      label: t('contact_channel_phone'),
      value: '+237 653 742 082',
      href: 'https://wa.me/237653742082',
      external: true,
    },
    {
      id: 'location',
      icon: MapPin,
      label: t('contact_channel_location'),
      value: 'Yaoundé, Cameroun',
    },
    {
      id: 'languages',
      icon: Languages,
      label: t('contact_channel_languages'),
      value: 'Français · English',
    },
  ];

  return (
    <aside className={`contact-aside ${className}`.trim()}>
      <div className="contact-aside__identity">
        <div className="contact-aside__avatar-wrap">
          <img
            src={portraitImage}
            alt={t('hero_name')}
            className="contact-aside__avatar"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="contact-aside__identity-body">
          <p className="contact-aside__name">{t('hero_name')}</p>
          <p className="contact-aside__role">{t('hero_role')}</p>
          <p className="contact-aside__response">
            <Clock size={14} aria-hidden="true" />
            {t('contact_response')}
          </p>
        </div>
      </div>

      <div className="contact-aside__panel">
        <h3 className="contact-aside__label">{t('contact_channels_label')}</h3>
        <ul className="contact-channels">
          {channels.map((channel) => {
            const Icon = channel.icon;
            return (
              <li key={channel.id} className="contact-channel">
                <span className="contact-channel__icon" aria-hidden="true">
                  <Icon size={16} />
                </span>
                <div className="contact-channel__body">
                  <span className="contact-channel__label">{channel.label}</span>
                  {channel.href ? (
                    <a
                      href={channel.href}
                      target={channel.external ? '_blank' : undefined}
                      rel={channel.external ? 'noopener noreferrer' : undefined}
                      className="contact-channel__value"
                    >
                      {channel.value}
                    </a>
                  ) : (
                    <span className="contact-channel__value">{channel.value}</span>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="contact-aside__actions">
        <a
          href="https://wa.me/237693690308"
          target="_blank"
          rel="noopener noreferrer"
          className="rihen-btn rihen-btn-primary interactive-button contact-aside__action"
        >
          <MessageCircle size={16} aria-hidden="true" />
          {t('contact_whatsapp')}
        </a>
        <a
          href="https://www.linkedin.com/in/florent-martial-talla-fossi-291ab8172"
          target="_blank"
          rel="noopener noreferrer"
          className="rihen-btn rihen-btn-outline interactive-button contact-aside__action"
        >
          <Linkedin size={16} aria-hidden="true" />
          {t('contact_linkedin')}
        </a>
      </div>
    </aside>
  );
};

export default ContactAside;
